import React from "react"

import { parse } from "node-html-parser"

import Agenda from "../landing_pages/Agenda"
import AgendaBusinessWeek from "../landing_pages/AgendaBusinessWeek"
import AlumniSection from "../AlumniSection"
import Application from "../Application"
import BlogLatestSection from "../BlogLatestSection"
import BulletinBoardCard from "../BulletinBoardCard"
import BulletinBoardSection from "../BulletinBoardSection"
import ConferenceGenericSection from "../conferences/ConferenceGenericSection"
import ConferenceBackgroundImageLeft from "../conferences/ConferenceBackgroundImageLeft"
import ConferenceVideoSectionLeft from "../conferences/ConferenceVideoSectionLeft"
import ConferenceVideoSectionRight from "../conferences/ConferenceVideoSectionRight"
import ContactUs from "../ContactUs"
import ContentCardSection from "../ContentCardSection"
import ContentDump from "../ContentDump"
import CourseAtGlance from "../CourseAtGlance"
import CourseDetailHeader from "../CourseDetailHeader"
import CourseTimetable from "../CourseTimetable"
import CourseSummary from "../CourseSummary"
import CourseSection from "../CourseSection"
import ChallengeSection from "../ChallengeSection"
import CustomersSection from "../CustomersSection"
import DoubleColumnSection from "../DoubleColumnSection"
import EduHeroSection from "../EduHeroSection"
import EduCard from "../EduCard"
import Events from "../Events"
import EventHighlightRightImage from "../landing_pages/EventHighlightRightImage"
import EventHighlightLeftImage from "../landing_pages/EventHighlightLeftImage"
import FeaturesSection from "../FeaturesSection"
import FiveColumnSection from "../FiveColumnSection"
import HeroSection from "../HeroSection"
import HeroCard from "../HeroCard"
import Hero from "../Hero"
import ImageSection from "../ImageSection"
import LandingImageSection from "../landing_pages/LandingImageSection"
import LinksSection from "../LinksSection"
import TabbedData from "../TabbedData"
import TextSectionWithList from "../TextSectionWithList"
import TextSliderSection from "../TextSliderSection"
import TextSliderCta from "../TextSliderCta"

import TestimonialSection from "../TestimonialSection"
import Testimonial from "../Testimonial"
import TM1PAConference2025RegistrationForm from "../landing_pages/TM1PAConference2025RegistrationForm"

import NewsSection from "../NewsSection"
import News from "../News"

import GenericSection from "../GenericSection"

import Slider from "../Slider"
import SliderSection from "../SliderSection"
import SolutionsHeroSection from "../SolutionsHeroSection"
import SupportHeroSection from "../SupportHeroSection"

import TrainingStyle from "../TrainingStyle"
import ThreeBannerSection from "../ThreeBannerSection"
import TwoColumnTextSection from "../TwoColumnTextSection"
import EduNews from "../EduNews"
import EduNewsSection from "../EduNewsSection"
import SectionImageLeft from "../SectionImageLeft"
import SectionImageRight from "../SectionImageRight"
import SectionImageRightTable from "../SectionImageRightTable"
import SectionImageRightSupport from "../SectionImageRightSupport"
import SectionImageLeftSupport from "../SectionImageLeftSupport"
import SectionImageRightWithList from "../SectionImageRightWithList"
import SectionImageLeftMultipleLinks from "../SectionImageLeftMultipleLinks"
import SimpleMobileNewsSection from "../SimpleMobileNewsSection"
import ResourcesSection from "../ResourcesSection"
import SupplyFocusHeroSection from "../SupplyFocusHeroSection"
import FourColumnSection from "../FourColumnSection"
import ThreeColumnSection from "../ThreeColumnSection"
import TextSection from "../TextSection"
import TalkToUs from "../TalkToUs"
import EducationPlan from "../EducationPlan"
import EducationSectionWithList from "../EducationSectionWithList"
import ExpandableContent from "../ExpandableContent"
import CoursesAgenda from "../CoursesAgenda"
import SpontaneousApplication from "../SpontaneousApplication"
import FunctionsLibrary from "../FunctionsLibrary"
import AboutValues from "../AboutValues"
import OurPeople from "../OurPeople"
import TwoColumnSection from "../TwoColumnSection"
import MembershipPlan from "../MembershipPlan"
import ThreeCardSection from "../ThreeCardSection"
import CountdownSection from "../landing_pages/CountdownSection"
import CtaSection from "../CtaSection"
import CtaSectionEdu from "../CtaSectionEdu"
import SimpleBlogLatestSection from "../SimpleBlogLatestSection"
import VideoSection from "../VideoSection"
import Action from "../world_championships/Action"
import Quiz from "../world_championships/Quiz"
import Rankings from "../world_championships/Rankings"
import HeroSectionChampionship from "../world_championships/HeroSectionChampionship"
import Intro from "../world_championships/Intro"
import MotivatorSeparator from "../world_championships/MotivatorSeparator"
import Participation from "../world_championships/Participation"
import HallFame from "../world_championships/HallFame"
import CallToAction from "../world_championships/CallToAction"
import CallToActionB from "../world_championships/CallToActionB"
import RegisterNow from "../world_championships/RegisterNow"
import Highlights from "../world_championships/Highlights"
import Merchandise from "../world_championships/Merchandise"
import Scores from "../world_championships/Scores"
import HeroSectionWithImageRight from "../landing_pages/HeroSectionWithImageRight"
import LandingGenericSectionWithList from "../landing_pages/LandingGenericSectionWithList"
import LandingSectionImageLeft from "../landing_pages/LandingSectionImageLeft"
import FormWithImageRight from "../landing_pages/FormWithImageRight"
import LandingTwoColumnListSection from "../landing_pages/LandingTwoColumnListSection"
import LandingTwoColumnListSectionWithImage from "../landing_pages/LandingTwoColumnListSectionWithImage"
import LandingSectionImageRight from "../landing_pages/LandingSectionImageRight"
import FaqSection from "../landing_pages/FaqSection"
import LocationInformation from "../landing_pages/LocationInformation"
import LocationInformationImageLeft from "../landing_pages/LocationInformationImageLeft"
import LandingCardWithList from "../landing_pages/LandingCardWithList"
import LandingTextSection from "../landing_pages/LandingTextSection"
import FormCheckboxWithImageRight from "../landing_pages/FormCheckboxWithImageRight"
import RegistrationFormTM1PyWorkshop from "../landing_pages/RegistrationFormTM1PyWorkshop"
import RegistrationFormSingapore from "../landing_pages/RegistrationFormSingapore"
import OverlayImageLeft from "../landing_pages/OverlayImageLeft"
import SectionBackgroundImageLeft from "../landing_pages/SectionBackgroundImageLeft"
import RegisterForm from "../landing_pages/RegisterForm"
import RegisterFormMelbourne from "../landing_pages/RegisterFormMelbourne"
import ThankYou from "../landing_pages/ThankYou"
import ThankYouContactingUs from "../ThankYouContactingUs"
import LandingImageTop from "../landing_pages/LandingImageTop"
import ListVideoDisplay from "../functions_library/ListVideoDisplay"
import InfoQueryCard from "../functions_library/InfoQueryCard"
import CourseTestimonials from "../CourseTestimonials"
import SplitViewLargeTextImageRight from "../landing_pages/SplitViewLargeTextImageRight"
import BannerSection from "../world_championships/BannerSection"
import SheetHero from "../beyond_spreadsheet/SheetHero"
import CineHero from "../beyond_spreadsheet/CineHero"
import ReelReviews from "../beyond_spreadsheet/ReelReviews"
import TwoColumnImage from "../beyond_spreadsheet/TwoColumnImage"
import MultiVideoDisplay from "../beyond_spreadsheet/MultiVideoDisplay"
import SkillsOverviewCardRight from "../SkillsOverviewCardRight"
import SkillsOverviewCardLeft from "../SkillsOverviewCardLeft"
import ThreeImageCards from "../ThreeImageCards"
import TrailersSection from "../beyond_spreadsheet/TrailersSection"
import TextAgendaLayout from "../landing_pages/TextAgendaLayout"
import Speakers from "../landing_pages/Speakers"
import HeaderWithImage from "../world_championships/HeaderWithImage"
import ChampionshipOverview from "../world_championships/ChampionshipOverview"
import ChampionshipDetails from "../world_championships/ChampionshipDetails"
import TM1pyRegistrationFormSingapore from "../landing_pages/TM1pyRegistrationFormSingapore"
import RegistrationFormAiMining from "../landing_pages/RegistrationFormAiMining"

export default function ComponentFactory(
  html,
  props = {},
  unsafeDisplay = true,
) {
  if (!html) return <></>

  const root = parse(html.replace(/[\r\n]/gm, ""))
  if (!root.childNodes) return <></>
  // console.log("root.childNodes", root.childNodes)

  const outerHtmlElements = root.childNodes.filter(
    node => node.childNodes.length,
  )
  if (!outerHtmlElements.length) return <></>
  // console.log("outerHtmlElements.length", outerHtmlElements[0].classNames)

  const reactElements = outerHtmlElements.map((htmlElement, elemIndx) => {
    const classNames = htmlElement.classNames.trim().split(/\s+/)
    // console.log(classNames)

    const componentId = classNames.filter(name => name.startsWith("cw-"))[0]
    // console.log(componentId)

    const componentOriginalId = htmlElement.id
    // console.log(componentOriginalId)

    switch (componentId) {
      case "cw-agenda":
        return (
          <Agenda
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></Agenda>
        )

        case "cw-agenda-business-week":
        return (
          <AgendaBusinessWeek
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></AgendaBusinessWeek>
        )
        case "cw-header-with-image":
          return (
            <HeaderWithImage
              key={elemIndx}
              content={htmlElement}
              pageContext={props.pageContext}
              modals={props.modals}
              className={classNames
                .filter(cn => !cn.startsWith(`wp-`))
                .map(cn => `icw-` + cn)
                .join(` `)}
            ></HeaderWithImage>
          )

          case "cw-championship-overview":
          return (
            <ChampionshipOverview
              key={elemIndx}
              content={htmlElement}
              pageContext={props.pageContext}
              modals={props.modals}
              className={classNames
                .filter(cn => !cn.startsWith(`wp-`))
                .map(cn => `icw-` + cn)
                .join(` `)}
            ></ChampionshipOverview>
          )

          case "cw-championship-details":
          return (
            <ChampionshipDetails
              key={elemIndx}
              content={htmlElement}
              pageContext={props.pageContext}
              className={classNames
                .filter(cn => !cn.startsWith(`wp-`))
                .map(cn => `icw-` + cn)
                .join(` `)}
            ></ChampionshipDetails>
          )


      case "cw-list-video-display":
        return (
          <ListVideoDisplay
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></ListVideoDisplay>
        )
      case "cw-info-query-card":
        return (
          <InfoQueryCard
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></InfoQueryCard>
        )

      case "cw-course-testimonials":
        return (
          <CourseTestimonials
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></CourseTestimonials>
        )

      case "cw-countdown-section":
        return (
          <CountdownSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></CountdownSection>
        )

      case "cw-banner-section":
        return (
          <BannerSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></BannerSection>
        )

      case "cw-split-view-large-text-image-right":
        return (
          <SplitViewLargeTextImageRight
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></SplitViewLargeTextImageRight>
        )

      case "cw-bulletin-board-card":
        return (
          <BulletinBoardCard
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></BulletinBoardCard>
        )

      case "cw-conference-generic-section":
        return (
          <ConferenceGenericSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></ConferenceGenericSection>
        )

      case "cw-conference-background-image-left":
        return (
          <ConferenceBackgroundImageLeft
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></ConferenceBackgroundImageLeft>
        )

      case "cw-hero-section":
        return (
          <HeroSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></HeroSection>
        )
      case "cw-education-section-with-list":
        return (
          <EducationSectionWithList
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          />
        )

      case "cw-expandable-content":
        return (
          <ExpandableContent
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          />
        )
      case "cw-edu-hero-section":
        return (
          <EduHeroSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></EduHeroSection>
        )

      case "cw-event-highlight-right-image":
        return (
          <EventHighlightRightImage
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></EventHighlightRightImage>
        )

      case "cw-event-highlight-left-image":
        return (
          <EventHighlightLeftImage
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></EventHighlightLeftImage>
        )

      case "cw-landing-hero-section-image-right":
        return (
          <HeroSectionWithImageRight
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></HeroSectionWithImageRight>
        )

      case "cw-landing-image-section":
        return (
          <LandingImageSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></LandingImageSection>
        )

      case "cw-landing-image-top":
        return (
          <LandingImageTop
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></LandingImageTop>
        )

      case "cw-landing-generic-section-with-list":
        return (
          <LandingGenericSectionWithList
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></LandingGenericSectionWithList>
        )

      case "cw-landing-section-image-left":
        return (
          <LandingSectionImageLeft
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></LandingSectionImageLeft>
        )

      case "cw-landing-two-column-list-section":
        return (
          <LandingTwoColumnListSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></LandingTwoColumnListSection>
        )

      case "cw-landing-two-column-list-with-image":
        return (
          <LandingTwoColumnListSectionWithImage
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></LandingTwoColumnListSectionWithImage>
        )

      case "cw-register-form":
        return (
          <RegisterForm
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            componentOriginalId={componentOriginalId}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></RegisterForm>
        )

      case "cw-register-form-melbourne":
        return (
          <RegisterFormMelbourne
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            componentOriginalId={componentOriginalId}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></RegisterFormMelbourne>
        )

      case "cw-thank-you":
        return (
          <ThankYou
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></ThankYou>
        )

      case "cw-text-agenda-layout":
        return (
          <TextAgendaLayout
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></TextAgendaLayout>
        )

      case "cw-thank-you-contacting-us":
        return (
          <ThankYouContactingUs
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></ThankYouContactingUs>
        )

      case "cw-landing-section-image-right":
        return (
          <LandingSectionImageRight
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></LandingSectionImageRight>
        )

      case "cw-location-information":
        return (
          <LocationInformation
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></LocationInformation>
        )

      case "cw-location-information-image-left":
        return (
          <LocationInformationImageLeft
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></LocationInformationImageLeft>
        )

      case "cw-landing-card-with-list":
        return (
          <LandingCardWithList
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></LandingCardWithList>
        )

      case "cw-landing-text-section":
        return (
          <LandingTextSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></LandingTextSection>
        )

      case "cw-overlay-image-left":
        return (
          <OverlayImageLeft
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></OverlayImageLeft>
        )

      case "cw-section-background-image-left":
        return (
          <SectionBackgroundImageLeft
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></SectionBackgroundImageLeft>
        )

      case "cw-form-checkbox-with-image-right":
        return (
          <FormCheckboxWithImageRight
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></FormCheckboxWithImageRight>
        )
      case "cw-faq-section":
        return (
          <FaqSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></FaqSection>
        )

      case "cw-form-with-image-right":
        return (
          <FormWithImageRight
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></FormWithImageRight>
        )

      case "cw-registration-form-tm1py-workshop":
        return (
          <RegistrationFormTM1PyWorkshop
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></RegistrationFormTM1PyWorkshop>
        )

      case "cw-registration-form-ai-mining":
        return (
          <RegistrationFormAiMining
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></RegistrationFormAiMining>
        )

      case "cw-registration-form-singapore":
        return (
          <RegistrationFormSingapore
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></RegistrationFormSingapore>
        )

      case "cw-registration-form-tm1py-workshop-singapore":
        return (
          <TM1pyRegistrationFormSingapore
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></TM1pyRegistrationFormSingapore>
        )

      case "cw-hero-section-championship":
        return (
          <HeroSectionChampionship
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></HeroSectionChampionship>
        )
      case "cw-intro-championship":
        return (
          <Intro
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></Intro>
        )
      case "cw-motivator-separator":
        return (
          <MotivatorSeparator
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></MotivatorSeparator>
        )

      case "cw-participation":
        return (
          <Participation
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></Participation>
        )

      case "cw-hall-fame":
        return (
          <HallFame
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></HallFame>
        )

      case "cw-call-to-action":
        return (
          <CallToAction
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></CallToAction>
        )

      case "cw-call-to-action-versionb-championship":
        return (
          <CallToActionB
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></CallToActionB>
        )

      case "cw-register-now":
        return (
          <RegisterNow
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            componentOriginalId={componentOriginalId}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></RegisterNow>
        )

      case "cw-image-section":
        return (
          <ImageSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></ImageSection>
        )

      case "cw-two-column-text-section":
        return (
          <TwoColumnTextSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></TwoColumnTextSection>
        )

      case "cw-five-column-section":
        return (
          <FiveColumnSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></FiveColumnSection>
        )

      case "cw-three-card-section":
        return (
          <ThreeCardSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></ThreeCardSection>
        )

      case "cw-cta-section-edu":
        return (
          <CtaSectionEdu
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></CtaSectionEdu>
        )

      case "cw-cta-section":
        return (
          <CtaSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></CtaSection>
        )

      case "cw-links-section":
        return (
          <LinksSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></LinksSection>
        )

      case "cw-customers-section":
        return (
          <CustomersSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></CustomersSection>
        )

      case "cw-generic-section":
        return (
          <GenericSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></GenericSection>
        )

      case "cw-hero-block":
        return (
          <Hero
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></Hero>
        )

      case "cw-hero-card-wrapper":
        return (
          <HeroCard
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></HeroCard>
        )
      case "cw-about-values":
        return (
          <AboutValues
            key={elemIndx}
            posts={props.wpPosts}
            pageContext={props.pageContext}
            content={htmlElement}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></AboutValues>
        )
      case "cw-functions-library":
        return (
          <FunctionsLibrary
            key={elemIndx}
            posts={props.wpPosts}
            pageContext={props.pageContext}
            content={htmlElement}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></FunctionsLibrary>
        )
      case "cw-spontaneous-application":
        return (
          <SpontaneousApplication
            key={elemIndx}
            posts={props.wpPosts}
            pageContext={props.pageContext}
            content={htmlElement}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></SpontaneousApplication>
        )

      case "cw-submit-application":
        return (
          <Application
            key={elemIndx}
            posts={props.wpPosts}
            pageContext={props.pageContext}
            content={htmlElement}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></Application>
        )

      case "cw-simple-news-section":
        return (
          <SimpleMobileNewsSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></SimpleMobileNewsSection>
        )

      case "cw-double-column-section":
        return (
          <DoubleColumnSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></DoubleColumnSection>
        )

      case "cw-events":
        return (
          <Events
            key={elemIndx}
            content={htmlElement}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></Events>
        )

      case "cw-education-plan":
        return (
          <EducationPlan
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></EducationPlan>
        )
      case "cw-three-column-section":
        return (
          <ThreeColumnSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></ThreeColumnSection>
        )

      case "cw-four-column-section":
        return (
          <FourColumnSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></FourColumnSection>
        )

      case "cw-text-section-with-list":
        return (
          <TextSectionWithList
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></TextSectionWithList>
        )

      case "cw-text-slider-section":
        return (
          <TextSliderSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></TextSliderSection>
        )
      case "cw-two-column-section":
        return (
          <TwoColumnSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></TwoColumnSection>
        )
      case "cw-training-styles":
        return (
          <TrainingStyle
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></TrainingStyle>
        )

      case "cw-text-slider-cta":
        return (
          <TextSliderCta
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></TextSliderCta>
        )

      case "cw-testimonial-section":
        return (
          <TestimonialSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></TestimonialSection>
        )
      case "cw-testimonial":
        return (
          <Testimonial
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></Testimonial>
        )

      case "cw-slider-section":
        return (
          <SliderSection
            key={elemIndx}
            content={htmlElement}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></SliderSection>
        )

      case "cw-news-section":
        return (
          <NewsSection
            key={elemIndx}
            content={htmlElement}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></NewsSection>
        )

      case "cw-news":
        return (
          <News
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></News>
        )

      case "cw-slider":
        return (
          <Slider
            key={elemIndx}
            content={htmlElement}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></Slider>
        )

      case "cw-edu-news-section":
        return (
          <EduNewsSection
            key={elemIndx}
            content={htmlElement}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></EduNewsSection>
        )

      case "cw-edu-news":
        return <EduNews key={elemIndx} content={htmlElement}></EduNews>

      case "cw-tabbed-data":
        return (
          <TabbedData
            key={elemIndx}
            content={htmlElement}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></TabbedData>
        )

      case "cw-resources":
        return (
          <ResourcesSection
            key={elemIndx}
            posts={props.wpPosts}
            pageContext={props.pageContext}
            content={htmlElement}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></ResourcesSection>
        )

      case "cw-blog-latest":
        return (
          <BlogLatestSection
            key={elemIndx}
            posts={props.wpPosts}
            pageContext={props.pageContext}
            content={htmlElement}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></BlogLatestSection>
        )

      case "cw-simple-blog-latest":
        return (
          <SimpleBlogLatestSection
            key={elemIndx}
            posts={props.wpPosts}
            pageContext={props.pageContext}
            modals={props.modals}
            content={htmlElement}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></SimpleBlogLatestSection>
        )

      case "cw-talk-to-us":
        return <TalkToUs key={elemIndx} content={htmlElement}></TalkToUs>

      case "cw-challenge-section":
        return (
          <ChallengeSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
          ></ChallengeSection>
        )

      case "cw-features-section":
        return (
          <FeaturesSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></FeaturesSection>
        )
      case "cw-contact-us":
        return (
          <ContactUs
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></ContactUs>
        )
      case "cw-skills-overview-card-left":
        return (
          <SkillsOverviewCardLeft
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></SkillsOverviewCardLeft>
        )

      case "cw-skills-overview-card-right":
        return (
          <SkillsOverviewCardRight
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></SkillsOverviewCardRight>
        )

      case "cw-solutions-hero-section":
        return (
          <SolutionsHeroSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></SolutionsHeroSection>
        )

      case "cw-support-hero-section":
        return (
          <SupportHeroSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></SupportHeroSection>
        )
      case "cw-supplyfocus-hero-section":
        return (
          <SupplyFocusHeroSection
            key={elemIndx}
            content={htmlElement}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></SupplyFocusHeroSection>
        )
      case "cw-section-image-left":
        return (
          <SectionImageLeft
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></SectionImageLeft>
        )

      case "cw-speakers":
        return (
          <Speakers
            key={elemIndx}
            content={htmlElement}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></Speakers>
        )

      case "cw-bulletin-board-section":
        return (
          <BulletinBoardSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></BulletinBoardSection>
        )

      case "cw-section-rightImage":
        return (
          <SectionImageRight
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></SectionImageRight>
        )

      case "cw-section-image-right-table":
        return (
          <SectionImageRightTable
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></SectionImageRightTable>
        )

      case "cw-section-image-right-with-list":
        return (
          <SectionImageRightWithList
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></SectionImageRightWithList>
        )

      case "cw-section-rightImageSupport":
        return (
          <SectionImageRightSupport
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></SectionImageRightSupport>
        )

      case "cw-section-image-left-support":
        return (
          <SectionImageLeftSupport
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></SectionImageLeftSupport>
        )

      case "cw-content-card-section":
        return (
          <ContentCardSection
            key={elemIndx}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
          ></ContentCardSection>
        )

      case "cw-edu-course-at-glance":
        return (
          <CourseAtGlance
            key={elemIndx}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
          ></CourseAtGlance>
        )

      case "cw-edu-course-detail-header":
        return (
          <CourseDetailHeader
            key={elemIndx}
            content={htmlElement}
          ></CourseDetailHeader>
        )
      case "cw-course-timetable":
        return (
          <CourseTimetable
            key={elemIndx}
            content={htmlElement}
          ></CourseTimetable>
        )
      case "cw-course-summary":
        return (
          <CourseSummary key={elemIndx} content={htmlElement}></CourseSummary>
        )

      case "cw-edu-course-information":
        return (
          <CourseSection key={elemIndx} content={htmlElement}></CourseSection>
        )

      case "cw-tm1pa-conference-2025-registration-form":
        return (
          <TM1PAConference2025RegistrationForm
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            componentOriginalId={componentOriginalId}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></TM1PAConference2025RegistrationForm>
        )

      case "cw-membership-plan":
        return (
          <MembershipPlan
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></MembershipPlan>
        )
      case "cw-edu-card":
        return (
          <EduCard
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></EduCard>
        )
      case "cw-text-section":
        return (
          <TextSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></TextSection>
        )

      case "cw-alumni-section":
        return (
          <AlumniSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></AlumniSection>
        )
      case "cw-three-banner-section":
        return (
          <ThreeBannerSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></ThreeBannerSection>
        )

      case "cw-courses-agenda":
        return (
          <CoursesAgenda
            key={elemIndx}
            content={htmlElement}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></CoursesAgenda>
        )

      case "cw-our-people":
        return (
          <OurPeople
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
          ></OurPeople>
        )

      case "cw-content-dump":
        return (
          <ContentDump
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            modals={props.modals}
          ></ContentDump>
        )

      case "cw-video-section":
        return (
          <VideoSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></VideoSection>
        )
      case "cw-conference-video-section-left":
        return (
          <ConferenceVideoSectionLeft
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></ConferenceVideoSectionLeft>
        )
      case "cw-conference-video-section-right":
        return (
          <ConferenceVideoSectionRight
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></ConferenceVideoSectionRight>
        )
      case "cw-section-image-left-multiple-links":
        return (
          <SectionImageLeftMultipleLinks
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></SectionImageLeftMultipleLinks>
        )

      case "cw-wc-rankings":
        return (
          <Rankings
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></Rankings>
        )

      case `cw-wc-quiz`:
        return (
          <Quiz
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></Quiz>
        )

      case `cw-wc-highlights`:
        return (
          <Highlights
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></Highlights>
        )

      case `cw-wc-merchandise`:
        return (
          <Merchandise
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></Merchandise>
        )

      case `cw-wc-action`:
        return (
          <Action
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></Action>
        )

      case `cw-wc-scores`:
        return (
          <Scores
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></Scores>
        )

      case `cw-sheet-hero`:
        return (
          <SheetHero
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></SheetHero>
        )

      case `cw-cine-hero`:
        return (
          <CineHero
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></CineHero>
        )

      case `cw-reel-reviews`:
        return (
          <ReelReviews
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></ReelReviews>
        )

      case `cw-two-column-image`:
        return (
          <TwoColumnImage
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></TwoColumnImage>
        )

      case `cw-multiple-video-display`:
        return (
          <MultiVideoDisplay
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></MultiVideoDisplay>
        )
      case "cw-three-image-cards":
        return (
          <ThreeImageCards
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></ThreeImageCards>
        )

      case `cw-trailers-section`:
        return (
          <TrailersSection
            key={elemIndx}
            content={htmlElement}
            pageContext={props.pageContext}
            className={classNames
              .filter(cn => !cn.startsWith(`wp-`))
              .map(cn => `icw-` + cn)
              .join(` `)}
          ></TrailersSection>
        )

      /* case 'cw-batatas':
        return <Batatas content={htmlElement}></Batatas> */
      default:
        return !unsafeDisplay ? (
          <div key={elemIndx}></div>
        ) : (
          <div
            key={elemIndx}
            className={classNames.map(cn => `icw-` + cn).join(` `)}
            dangerouslySetInnerHTML={{
              __html: htmlElement.outerHTML,
            }}
          />
        )
    }
  })

  if (
    Object.keys(props).length >
    0 +
      Object.keys(props).includes(`pageContext`) +
      Object.keys(props).includes(`modals`)
  )
    return React.createElement(
      "div",
      { className: props.className },
      reactElements,
    )

  return reactElements
}
